module.exports = __webpack_public_path__ + "public/files/img/loading.64ee8686.svg";